import React from "react";
import { NavLink } from "react-router-dom";

import './style.css'
import { useTranslation } from "react-i18next";

export const FooterSpecial = ({ style }) => {
  const { t } = useTranslation()
  return (
    <section className={'footer'} style={{ ...style, background: '#FDFDFF' }}>
      <div className="container">
        <div className="row">
          <NavLink to='/'>
            <img src="/images/logo-ajg.png" width={185} alt="" />
          </NavLink>
        </div>

      </div>
    </section>


  )
}
